import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppSettings } from '../../app.settings';
import { JarwisService } from 'src/app/Services/jarwis.service';
import { TokenService } from 'src/app/Services/token.service';
import { AuthService } from 'src/app/Services/auth.service';
import { ToastrService } from 'ngx-toastr';
import * as shajs from 'sha.js';
import { MatDialog } from '@angular/material/dialog';
import { LoginResetPasswordPopupComponent } from '../login-reset-password-popup/login-reset-password-popup.component';
declare var setCaptcha: Function;
declare var myFun: Function;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @ViewChild('canvas', { static: true }) canvas: ElementRef<HTMLCanvasElement>;
  @ViewChild('canvas2', { static: true }) canvas2: ElementRef<HTMLCanvasElement>;
  answer: number;
  userText: any;
  submitButton: any;
  output: any;
  refreshButton: any;
  realCaptcha: any;
  ctx: any;

  public showInfoContent: boolean;
  public form: FormGroup;
  public payload: any;
  error: any;
  loginPerson: any;
  salt: any;

  constructor(
    public appSettings: AppSettings,
    public fb: FormBuilder,
    public router: Router,
    private jarwis: JarwisService,
    private token: TokenService,
    private auth: AuthService,
    private toastr: ToastrService,
    public dialog: MatDialog
  ) {
    this.form = this.fb.group({
      login_as: [null, Validators.required],
      email: [
        null,
        Validators.compose([Validators.required, Validators.email])
      ],
      password: [
        null,
        Validators.compose([Validators.required, Validators.minLength(6)])
      ],
      captcha: [null],
      originalCaptcha: [null],
      rememberMe: false
    });
  }

  ngOnInit() {
    this.createCaptcha();
    if (localStorage.getItem('loginPerson')) {
      this.loginPerson = localStorage.getItem('loginPerson') + ' Login';
    } else {
      this.loginPerson = 'Login';
    }

    if (localStorage.getItem('token')) {
      const data = {
        type: 'Success',
        token: localStorage.getItem('token')
      };
      this.handleResponse(data);
    }
  }

  createCaptcha() {
    // const ctx = this.canvas.nativeElement.getContext('2d');
    // const [numOne, numTwo] = [random(), random()];
    // this.answer = numOne + numTwo;

    // ctx.font = '30px Arial';
    // ctx.fillText(`${numOne} + ${numTwo} = `, 10, 35);

    this.ctx = this.canvas2.nativeElement.getContext("2d");
    this.ctx.font = "bold 42px Roboto";
    this.ctx.fillStyle = "#111111";

    this.userText = document.getElementById('textBox');
    this.submitButton = document.getElementById('submitButton');
    this.output = document.getElementById('output');
    this.refreshButton = document.getElementById('refreshButton');

    // alphaNums contains the characters with which you want to create the CAPTCHA
    let alphaNums = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    let emptyArr = [];

    // This loop generates a random string of 7 characters using alphaNums
    // Further this string is displayed as a CAPTCHA
    for (let i = 1; i <= 7; i++) {
      emptyArr.push(alphaNums[Math.floor(Math.random() * alphaNums.length)]);
    }
    this.realCaptcha = emptyArr.join('');
    this.ctx.fillText(emptyArr.join(''), 75, 75);
  }

  change(value: string) {
    return this.validate(value);
  }

  refreshCaptcha() {
    this.userText.value = "";
    let refreshArr = [];
    let alphaNums = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

    for (let j = 1; j <= 7; j++) {
      refreshArr.push(alphaNums[Math.floor(Math.random() * alphaNums.length)]);
    }
    this.ctx = this.canvas2.nativeElement.getContext("2d");
    this.ctx.clearRect(0, 0, 300, 150);
    this.realCaptcha = refreshArr.join('');
    this.ctx.fillText(refreshArr.join(''), 75, 75);
  }

  validate(value) {
    if (this.realCaptcha === value) {
      return 0;
    } else {
      return 1;
    }
    // const isNotValid = this.answer !== Number(value);

    // return (
    //   isNotValid && {
    //     invalid: true
    //   }
    // );
  }

  onSubmit(values) {
    if (!this.validate(values['captcha'])) {
      let tempEmail = this.form.controls.email.value;
      let lowerCaseEmail = tempEmail.toLowerCase();
      let encryptedEmail = btoa(lowerCaseEmail);
      this.jarwis.createSalt({'email' : encryptedEmail}).subscribe(
        data => {
          if (data['type'] == 'Success') {
            values['email'] = encryptedEmail;
            let encryptedPassword = shajs('sha512').update(this.form.controls.password.value + encryptedEmail).digest('hex');
            let finalEncryptedPassword = shajs('sha512').update(encryptedPassword + data['salt']).digest('hex');
            values['password'] = finalEncryptedPassword;
            values['captcha'] = btoa(this.form.controls.captcha.value + "Success");
            values['orgCaptcha'] = btoa(this.form.controls.captcha.value);
            this.jarwis.login(this.form.value).subscribe(
              data => this.handleResponse(data),
              error => this.handleError(error)
            );
          } else {
            this.toastr.error(data['message'])
          }
        });
    } else {
      this.toastr.error('Invalid Captcha! Please try again.');
      this.refreshCaptcha();
    }
  }

  handleResponse(data) {
    // console.log(data.headers.get('Set-Cookie'));
    if (data['type'] == 'Error') {
      if (data['message'] == 'Password Expired') {
        // const dialogRef = this.dialog.open(LoginResetPasswordPopupComponent, {
        //   height: '95%', width: '45%', disableClose: true
        // });
        this.router.navigateByUrl('/request-password-reset-otp');
      }
      this.toastr.error(data['message']);
      this.form.reset();
      this.refreshCaptcha();
    }

    this.token.handle(data.token);
    this.auth.changeStatus(true);
    this.payload = this.token.payload(data.token);

    const role = this.payload['role_id'];
    localStorage.setItem('role', role);
    sessionStorage.setItem('xsrf', data.name);

    switch (role) {
      case 1: {
        this.router.navigateByUrl('/admin/user-management');
        break;
      }
      case 2: {
        this.router.navigateByUrl('/super-admin');
        break;
      }
      case 3: {
        this.router.navigateByUrl('/expert');
        break;
      }
      case 4: {
        this.router.navigateByUrl('/moderator');
        break;
      }
      case 5: {
        this.router.navigateByUrl('/institute');
        break;
      }
      case 6: {
        this.router.navigateByUrl('/student/basic-details');
        break;
      }
      // case 7: {
      //   this.router.navigateByUrl('/hod');
      //   break;
      // }
      case 8: {
        this.router.navigateByUrl('/faculty');
        break;
      }
      case 9: {
        this.router.navigateByUrl('/finance');
        break;
      }
      case 10: {
        this.router.navigateByUrl('/nodal-officer');
        break;
      }
      case 11: {
        this.router.navigateByUrl('/consultant');
        break;
      }
      default: {
        this.auth.logout();
      }
    }
  }

  handleError(error) {
    this.error = error.error.error;
    this.toastr.error(error.error.error);
  }
}

function random() {
  return Math.floor(Math.random() * 10) + 1;
}
